import { PaymentProcessingMethod } from '~entities/studios/model/types';

/**
 * Approve & Lock / Unlock are always available (not gated by postpone toggle).
 * ENR-2162
 */
export function isPaymentRunApproveLockEnabled(_params?: {
  paymentRunPostponeCronEnabled?: boolean | null;
  paymentProcessingMethod?: PaymentProcessingMethod | string | null;
}): boolean {
  return true;
}

/**
 * Postpone is Manual-only and requires the settings toggle.
 * Auto studios cannot postpone. ENR-2162
 */
export function isPaymentRunPostponeEnabled(params: {
  paymentRunPostponeCronEnabled?: boolean | null;
  paymentProcessingMethod?: PaymentProcessingMethod | string | null;
}): boolean {
  if (params.paymentProcessingMethod !== PaymentProcessingMethod.MANUAL) {
    return false;
  }
  return params.paymentRunPostponeCronEnabled === true;
}

/**
 * @deprecated Prefer isPaymentRunApproveLockEnabled / isPaymentRunPostponeEnabled.
 */
export function isPaymentRunReviewControlsEnabled(params: {
  paymentRunPostponeCronEnabled?: boolean | null;
  paymentProcessingMethod?: PaymentProcessingMethod | string | null;
}): boolean {
  return (
    isPaymentRunApproveLockEnabled(params) ||
    isPaymentRunPostponeEnabled(params)
  );
}
